import {
  LayoutRulesDataSchema,
  ObjectAttributeType,
} from '@celito.clients/types';
import { createContext } from 'react';

import {
  ApiValidationError,
  WizardStepState,
} from '../components/form-wizard/form-wizard.model';
import { FormEngineContextType } from '../types';

export const FormEngineContext = createContext<FormEngineContextType>({
  fieldsState: {},
  wizardStepsState: [],
});

interface FormEngineContextProviderProps {
  children: React.ReactNode;
  fieldsState: Record<string, LayoutRulesDataSchema>;
  setFieldsState?: React.Dispatch<
    React.SetStateAction<Record<string, LayoutRulesDataSchema>>
  >;
  fetchAttributeConfig?: (objectName: string) => Promise<void>;
  isWizardStateVisible?: boolean;
  isCompleterBarVisible?: boolean;
  fieldsApiErrors?: ApiValidationError;
  setFieldsApiErrors?: React.Dispatch<React.SetStateAction<ApiValidationError>>;
  setWizardStepsState?: React.Dispatch<React.SetStateAction<WizardStepState[]>>;
  wizardStepsState?: WizardStepState[];
  outboundRelationships?: Record<string, { column: string; result: string[] }>;
  isAllSectionsValid?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
  onSave?: (recordData?: Record<string, unknown>) => void;
  objectDefinition?: ObjectAttributeType;
}

export const FormEngineContextProvider = ({
  children,
  fieldsState,
  setFieldsState,
  fetchAttributeConfig,
  isWizardStateVisible,
  isCompleterBarVisible,
  fieldsApiErrors,
  setFieldsApiErrors,
  setWizardStepsState,
  wizardStepsState,
  outboundRelationships,
  onCancel,
  onSubmit,
  onSave,
  isAllSectionsValid,
  objectDefinition,
}: FormEngineContextProviderProps) => {
  return (
    <FormEngineContext.Provider
      value={{
        fieldsState,
        setFieldsState,
        fetchAttributeConfig,
        isWizardStateVisible,
        isCompleterBarVisible,
        fieldsApiErrors,
        setFieldsApiErrors,
        setWizardStepsState,
        wizardStepsState,
        outboundRelationships,
        onCancel,
        onSubmit,
        onSave,
        isAllSectionsValid,
        objectDefinition,
      }}
    >
      {children}
    </FormEngineContext.Provider>
  );
};
